﻿import { IInputScope, KbInput } from "@app/components/kb-input/kb-input.component";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";
import { Utils } from "@tools";

export interface INumberboxScope extends IInputScope {
    /** see eFormatType: none, number, currency, percentage */
    format: string;
    minPrecision: number;
    maxPrecision: number;
    /** the currency iso code (only used if format = currency) */
    currency: string;
    thousandsSeparator: string;
    decimalSeparator: string;
    prefix: string;
    suffix: string;
    step: number;

    _formattedValue: string;
}

@NgComponent({
    token: Token.KbNumberbox,
    dependencies: [
        Token.$Timeout
    ]
})
export class KbNumberbox extends KbInput {
    constructor(
        $timeout: ng.ITimeoutService
    ) {
        super($timeout);

        this.scope = Utils.extend(this.scope, {
            format: "@",
            minPrecision: "@",
            maxPrecision: "@",
            currency: "@",
            thousandsSeparator: "@",
            decimalSeparator: "@",
            prefix: "@",
            suffix: "@",
            step: "@"
        });

        this.template = Dirs.component("kb-numberbox");

        this.link = (scope: INumberboxScope, element: ng.IAugmentedJQuery, atts: ng.IAttributes, controllers: any[]) => {
            this.kbInputLinkFn(scope, element, atts, controllers);

            scope.$watch("[ngModel,format,minPrecision,maxPrecision,currency,decimalSeparator,thousandsSeparator,prefix,suffix]", () => {
                if (scope.ngModel != null && !isNaN(scope.ngModel)) {
                    scope._formattedValue = (scope.ngModel as number).format({
                        formatType: scope.format,
                        minPrecision: Number(scope.minPrecision),
                        maxPrecision: Number(scope.maxPrecision),
                        currency: scope.currency,
                        decimalSeparator: scope.decimalSeparator,
                        thousandsSeparator: scope.thousandsSeparator,
                        prefix: scope.prefix,
                        suffix: scope.suffix
                    });
                } else {
                    scope._formattedValue = "";
                }
            });
        };
    }
}
